import { AscPathLoader, AscWagesLayout } from '@neo.tax/asc/organisms';
import { Path } from '@neo.tax/shared';

import { useAscWagesRedirect } from './hooks';

export const AscWages = (): React.ReactElement => (
  <AscPathLoader path={Path.ASC_WAGES} useRedirect={useAscWagesRedirect}>
    <AscWagesLayout />
  </AscPathLoader>
);
